import Select from 'react-select';
import styled, { css } from 'styled-components';
import { OptionType } from '.';

export const StyledSelect = styled(Select<OptionType, true>)`
	width: 100%;
	font-size: .925rem;
	margin-top: 0px;
	color: var(--textColor);

	.custom-map-select__control{
		border-radius: 8px;
		border-color: var(--inputBorderColor);
		background: var(--selectDropdownBgColor);

		.custom-map-select__indicator{
			padding: 8px 6px;
			color: rgb(176, 178, 180);
		}
		.custom-map-select__indicator-separator{
		    background-color: var(--inputBorderColor);
		}
	}
	
`;

export const CustomSelectWrap = styled.div`
		position:relative;
		.select-icon {
			position: absolute;
			left: 12px;
			top: 50%;
			transform: translateY(-50%);
			display: flex;
			align-items: center;
			color: var(--defaultIconColor);
			z-index: 1;
    	opacity: .5;

			path{
				stroke: var(--defaultIconColor);
			}
		}
		.custom-map-select__menu{
			background: var(--selectDropdownBgColor);
			border-radius: 4px;
			overflow: hidden;
		}
		.custom-map-select__menu-list{
			padding-top: 0;
			padding-bottom: 0;

			.custom-map-select__option{
			background: var(--selectDropdownBgColor);
			border-radius: 2px;
			}
		}
`;

export const HiddenFileInput = styled.input`
  display: none;
`;

export const UploadLabel = styled.label<{ $disabled?: boolean }>`
  width: 100%;
  height: auto;
  // background: var(--surfaceColor);
  padding: 10px;

  display: flex;
  align-items: center;
  justify-content: space-between;

  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  transition: all 0.2s ease;

  ${({ $disabled }) =>
		!$disabled &&
    css`
      &:hover {
        border-color: var(--iconMutedColor);
        background: var(--selectDropdownHoverColor);
      }
    `}
`;

export const UploadText = styled.span`
  font-size: 14px;
  color: var(--textColor);
	font-weight: 500;
`;
export const CustomSelectDiv = styled.div`
	padding: 10px 12px 10px 12px;
	display: flex;
	justify-content: space-between;
	flex-direction: row;
	flex-wrap: nowrap;
	font-size: 14px;
	gap: 10px;
	border-radius: 2px;
	align-items: center;
	position: relative;
	margin-bottom: 1px;
`;
export const CustomOptionDiv = styled.div`
	display: flex;
	flexDirection: row;
	align-items:center;
	justify-content:center;
	gap: 0px;
	width: auto;
	border-radius: 50%;
	cursor: pointer;

	// &:hover{
	// 	background: #fcfcfc;
	// }
`;

export const LabelDiv = styled.div`
	display: flex;
	flexDirection: row;
	gap: 10px;
	overflow: hidden;

	.drag-area{
		position: absolute;
		left:0;
		top: 0;
		height: 100%;
		padding: 10px 15px;
		cursor: grab;
		background: transparent;
		z-index: 9;
	}

	.custom-map-option-label{
		white-space: nowrap;
  	overflow: hidden;
  	text-overflow: ellipsis;
		max-width: fit-content;
		line-height: 1.4;   
		color: var(--textColor);
	}
`;

